import classNames from 'classnames';
import Image, { type ImageProps } from 'next/image';
import Circle from './image-circle-xmark-regular-full.svg';

export const MissingImage = ({
  width,
  height,
  className,
  ...props
}: Omit<ImageProps, 'src' | 'alt'>) => {
  const imageWidth = typeof width === 'number' ? width / 2 : undefined;
  const imageHeight = typeof height === 'number' ? height / 2 : undefined;

  return (
    <div
      className={classNames(
        'ui-flex ui-items-center ui-justify-center ui-bg-gray-200',
        className
      )}
      style={{
        width: width,
        height: height,
      }}
    >
      <Image
        src={Circle}
        alt="Missing image"
        width={imageWidth}
        height={imageHeight}
        className="ui-opacity-50"
        {...props}
      />
    </div>
  );
};
